import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { TaskbookService } from "app/frontend/lib/taskbook-triage/taskbook.service";
import { Review } from "app/frontend/lib/taskbook-triage/taskbook.types";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'task-last-update',
    templateUrl: './task-last-update.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TaskLastUpdateComponent implements OnInit {

    reviewer: string;

    @Input() review: Review;
    @Input() userId: string;

    constructor(
        protected translateService: TranslateService,
    ){}

    ngOnInit() {
        this.reviewer = this.review.reviewer.id === this.userId ? '' : this.review.reviewer.fullname + ' ';
    }
}